import { useQuery } from '@apollo/client/react'
import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { PileNodeConnection } from '@src/generated/schema'
import { Pile } from '@src/graphql/Pile'
import debounce from 'lodash.debounce'
import { MultiSelect, MultiSelectProps } from '@src/components/Elements/MultiSelect/MultiSelect'

export const LocationSelect: FC<Pick<MultiSelectProps, 'required'>> = (props) => {
  const { t } = useTranslation()
  const { data, loading, fetchMore, refetch } = useQuery<{ pileLocations: PileNodeConnection }>(Pile.getPileLocations, {
    variables: {
      first: 10,
    },
    fetchPolicy: 'network-only',
  })
  const { pileLocations: { edges } = { edges: [] as any } } = data || {}

  const handleSearch = useCallback(
    debounce((value: string) => {
      refetch({
        first: 10,
        searchString: value,
      })
    }, 100),
    [],
  )

  const handlePopupScroll = (e: any) => {
    e.persist()
    const scrollTop = e.target.scrollTop as number
    const offsetHeight = e.target.offsetHeight as number

    if (scrollTop + offsetHeight === e.target.scrollHeight) {
      fetchMore({
        variables: {
          after: data?.pileLocations.pageInfo.endCursor,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const newEdges = fetchMoreResult.pileLocations.edges
          const pageInfo = fetchMoreResult.pileLocations.pageInfo

          return newEdges.length
            ? {
                pileLocations: {
                  pageInfo,
                  __typename: prev.pileLocations.__typename,
                  edges: [...prev.pileLocations.edges, ...newEdges],
                },
              }
            : prev
        },
      })
    }
  }

  return (
    <MultiSelect
      {...props}
      label={t('desktop.pages.piles.list.columns.location')}
      options={edges.map(({ node: { name } }) => ({
        title: name,
        value: name,
      }))}
      name='location'
      loading={loading}
      onSearch={handleSearch}
      onPopupScroll={handlePopupScroll}
    />
  )
}
